import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const intercom = defineConnector({
  identifier: "intercom",
  name: "Intercom",
  tagLine: "Customer messaging and support",
  keywords: "chat helpdesk help desk tickets conversations contacts articles",
  logo,
  protocol: "http",
  tags: ["featured", "communication", "productivity"],
  defaultUrlPattern: () => "https://api\\.intercom\\.io/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Connect your Intercom workspace",
      items: [
        {
          kind: "oauth",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://app.intercom.com/oauth",
    tokenEndpoint: () => "https://api.intercom.io/auth/eagle/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "env",
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.intercom.io/me",
  },
});
